import { CircularProgress } from "@material-ui/core"

export default function Button( { loading, disabled = false, color, type, label, handlePress } ) {
  return (
    
    <button disabled={disabled} onClick={handlePress} 
      className={`${ loading && `flex flex-row justify-between items-center px-1` } bg-green-700 rounded-sm text-white px-5 py-1 text-sm focus:outline-none focus:border-none`}
      type={type}
      style={{ backgroundColor: color && "red" }}>
        <span>{label}</span>
        {loading && <CircularProgress size={14} color="primary" />}
    </button>
  )
}
